// extracted by mini-css-extract-plugin
export default {"statutory-component":"EditCompany_statutory-component__KPr5y","modal-header":"EditCompany_modal-header__QTppj","modal-header-filter":"EditCompany_modal-header-filter__8QlXz"};